import React from 'react';
import IconWarning from "../Icons/WarningIcon";

interface Props {
    message: string;
    margin?: string;
}

const AttentionBox: React.FC<Props> = (props: Props) => {

  const clsMargin = props.margin ? props.margin : "mt-4"
  return (
    <div className={"border border-orange-500 p-4 flex items-center gap-x-2 rounded-md " + clsMargin}>
      <IconWarning className="h-6 w-6" alt="attention"/>
      <div className="z-title3">
        {props.message}
      </div>

    </div>
  );
};

export default AttentionBox;
